
import { FilterOps, GQL_ID } from '@@types'

import { useFetchAllTextMaterials, useFetchSingleTextMaterial } from '@entities/Blog'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BlogPreview } from '@widgets/blog-preview'

export default function TextMaterialsBlock ({ block, payload }: BlockProps) {
  const { singleTextMaterial, loading } = useFetchSingleTextMaterial({
    id: payload?.id as GQL_ID
  })

  const { textMaterials, loading: loadingTextMaterials } = useFetchAllTextMaterials({
    filter: {
      fields: [ 'id' ],
      op: FilterOps.CONTAINS,
      value: payload?.ids as GQL_ID[] || []
    }
  })

  if (!payload) {
    return null
  }

  const name = payload?.name && (payload.name as string).length > 0 ? payload.name as string : undefined
  const isSingle = block.subtype === 'single'

  // Если single - показываем один материал
  if (isSingle && singleTextMaterial) {
    return (
      <div className={styles.root__blog}>
        <BlogPreview
          title={name}
          articles={[ singleTextMaterial ]}
          loading={loading}
        />
      </div>
    )
  }

  // Иначе показываем коллекцию материалов
  return (
    <div className={styles.root__blog}>
      <BlogPreview
        title={name}
        articles={textMaterials}
        loading={loadingTextMaterials}
      />
    </div>
  )
}
